/* eslint-disable no-extend-native */
import axios from 'axios'
import store from 'store'
import { dispatchLogout, dispatchUser } from 'tennders-auth/stores/action'
import { getStoreInstance } from 'tennders-common/stores/store'

export const getToken = () => (store.get('_t') && store.get('_t') !== '' ? store.get('_t') : null)
export const setToken = (token) => store.set('_t', token)
export const removeToken = () => store.remove('_t')

export const defaultOptions = (isFile) => {
  const headers = {
    'Content-Type': isFile ? 'multipart/form-data' : 'application/json',
    Accept: isFile ? 'multipart/form-data' : 'application/json',
    'Accept-Language': 'en-US'
  }
  const token = getToken()
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }
  if (typeof localStorage !== 'undefined') {
    const tempToken = localStorage.getItem('temp_token')
    if (tempToken) {
      headers['X-AUTH-TOKEN'] = tempToken
    }
  }
  return { headers }
}

export const baseURL = process.env.API_URL.replace('/api/v1', '')
export const defaultInstance = axios.create({ baseURL: process.env.API_URL })
export const guestInstance = axios.create({ baseURL })

defaultInstance.interceptors.request.use((config) => {
  config.headers = {
    ...defaultOptions(false).headers,
    ...config.headers
  }
  return config
})

const formatErrors = (errors) => {
  if (typeof errors !== 'object') {
    return { error: errors }
  }
  const e = {}
  for (let i = 0; i < Object.keys(errors).length; i += 1) {
    const key = Object.keys(errors)[i]
    if (key.includes('.')) {
      const parts = key.split('.')
      if (!e[parts[0]]) {
        e[parts[0]] = {}
      }
      e[parts[0]] = { ...e[parts[0]], [parts[1]]: errors[key] }
    } else {
      e[key] = errors[key]
    }
  }
  return { errors: e }
}

let isGetRequestInProgress = false
let apiGetURL = false
let apiGetParams = false
// skipProgress is for searchable input
export const apiGet = async (url, options = {}, skipProgress = false) => {
  try {
    // Check if a request is already in progress
    if (!skipProgress && isGetRequestInProgress && url === apiGetURL && JSON.stringify(options) === JSON.stringify(apiGetParams)) {
      // If a request is in progress, you can choose to return or throw an error
      return false
    }
    apiGetURL = url
    isGetRequestInProgress = true
    apiGetParams = options
    if (!options.params) {
      options.params = {}
    }
    options.params.tzo = new Date().getTimezoneOffset()
    const results = await defaultInstance.get(url, options)
    apiGetURL = false
    isGetRequestInProgress = false
    apiGetParams = false
    if (results?.data) {
      return results.data
    }
    return false
  } catch (ex) {
    apiGetURL = false
    isGetRequestInProgress = false
    apiGetParams = false
    // if we have errors in response that means we want to catch and show
    // these error messages in form
    if (ex.response?.status === 400 && ex.response?.data?.errors) {
      throw ex
    }
    // @todo do something smart here cucu
    return false
  }
}

let isPostRequestInProgress = false
let apiPostParams = false
let apiPostURL = false

export const apiPost = async (url, params, options = {}) => {
  try {
    // Check if a request is already in progress
    if (isPostRequestInProgress && url === apiPostURL && JSON.stringify(params) === JSON.stringify(apiPostParams)) {
      // If a request is in progress, you can choose to return or throw an error
      return false
    }
    apiPostURL = url
    apiPostParams = params
    // Set the flag to true to indicate that a request is in progress
    isPostRequestInProgress = true
    const results = await defaultInstance.post(url, { ...params, tzo: (new Date().getTimezoneOffset()) }, options)
    isPostRequestInProgress = false
    apiPostURL = false
    apiPostParams = false
    if (results.data) {
      return results.data
    }
    return results
  } catch (ex) {
    isPostRequestInProgress = false
    apiPostURL = false
    apiPostParams = false
    // if we have errors in response that means we want to catch and show
    // these error messages in form
    if (ex.response?.status === 400 && ex.response?.data?.errors) {
      throw ex
    }
    return formatErrors(ex)
  }
}

let isPutRequestInProgress = false
let apiPutParams = false
let apiPutURL = false

export const apiPut = async (url, params, options = {}) => {
  try {
    // Check if a request is already in progress
    if (isPutRequestInProgress && url === apiPutURL && JSON.stringify(params) === JSON.stringify(apiPutParams)) {
      // If a request is in progress, you can choose to return or throw an error
      return false
    }
    apiPutURL = url
    apiPutURL = params
    isPutRequestInProgress = true
    const results = await defaultInstance.put(url, { ...params, tzo: (new Date().getTimezoneOffset()) }, options)
    isPutRequestInProgress = false
    apiPutURL = false
    apiPutParams = false
    if (results.data) {
      return results.data
    }
    return results
  } catch (ex) {
    isPutRequestInProgress = false
    apiPutURL = false
    apiPutParams = false
    // if we have errors in response that means we want to catch and show
    // these error messages in form
    if (ex.response?.status === 400 && ex.response?.data?.errors) {
      throw ex
    }
    return formatErrors(ex)
  }
}

let isDeleteRequestInProgress = false
let apiDeleteURL = false
let apiDeleteParams = false

export const apiDelete = async (url, options = {}) => {
  try {
    // Check if a request is already in progress
    if (isDeleteRequestInProgress && url === apiDeleteURL && JSON.stringify(options) === JSON.stringify(apiDeleteParams)) {
      // If a request is in progress, you can choose to return or throw an error
      return false
    }
    apiDeleteURL = url
    isDeleteRequestInProgress = true
    apiDeleteParams = options
    const results = await defaultInstance.delete(url, options)
    isDeleteRequestInProgress = false
    apiDeleteURL = false
    apiDeleteParams = false
    if (results.data) {
      return results.data
    }
    if (results.status >= 200 && results.status < 300) {
      return true
    }

    return false
  } catch (ex) {
    isDeleteRequestInProgress = false
    apiDeleteURL = false
    apiDeleteParams = false
    // if we have errors in response that means we want to catch and show
    // these error messages in form
    if (ex.response?.status === 400 && ex.response?.data?.errors) {
      throw ex
    }
    // @todo do something smart here cucu
    return { error: ex }
  }
}

Date.prototype.toJSON = function() {
  const date = new Date(Date.UTC(this.getUTCFullYear(), this.getUTCMonth(),
    this.getUTCDate(), this.getUTCHours(),
    this.getUTCMinutes(), this.getUTCSeconds()))
  return date.toLocaleString('en-US')
}

export const apiLogin = async (form) => {
  try {
    const response = await axios.post(
      `${process.env.API_URL}/auth/login`,
      form
    )
    if (response.data.token) {
      setToken(response.data.token)
      if (response.data.redirectUrl) {
        return { redirectUrl: response.data.redirectUrl }
      }
      return true
    }
    return response
  } catch (ex) {
    return ex.response?.data ? formatErrors(ex.response.data.errors) : false
  }
}

export const logoutUser = () => {
  const store = getStoreInstance()

  store.dispatch(dispatchUser(false))
  removeToken()
  store.dispatch(dispatchLogout(true))
}
defaultInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      logoutUser()
      window.location = '/auth/login'
    }
    if (error.response && error.response.status === 400 && error.response.data.violations) {
      const v = error.response.data.violations
      const e = {}
      v.forEach((element) => {
        if (element.message.indexOf('::') > -1) {
          const parts = element.message.split('::')
          e[parts[0].trim()] = parts[1].trim()
        } else if (element.propertyPath.indexOf('.') > -1) {
          const parts = element.propertyPath.split('.')
          if (!e[parts[0].trim()]) {
            e[parts[0].trim()] = {}
          }
          e[parts[0].trim()][parts[1].trim()] = element.message
        } else {
          e[element.propertyPath] = element.message
        }
      })
      return { errors: e }
    }
    if (error.response && error.response.data && error.response.data.errors) {
      return Promise.reject(error)
    }
    if (error.response && error.response.data && error.response.data.error) {
      return Promise.reject(error.response.data.error)
    }
    return Promise.reject(error)
  }
)
